/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit PrimaryIndustrySicCode.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-500.js"
import * as fromData from 'Data/ViewsData.js'
import Dropdown from 'DesignSystem/Dropdown/logic.js'
import React from 'react'
import { css } from "emotion"
Dropdown.displayName = 'DropdownLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  marginTop: 'var(--marginTop)',
marginRight: 'var(--marginRight)',
marginLeft: 'var(--marginLeft)',
marginBottom: 'var(--marginBottom)'})
styles.Text = css({label: 'Text',
  color: "#606060",
fontFamily: "WonderUnitSans",
fontSize: 8,
fontWeight: 500,
letterSpacing: 1,
marginBottom: 8,
marginLeft: 10,
textTransform: "uppercase"})

export default function PrimaryIndustrySicCode({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  marginTop= 0,
marginRight= 8,
marginLeft= 0,
marginBottom= 0,
from,
onChange,
isInvalid,
value,
viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Add/PrimaryIndustrySicCode"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'company.primary_industry_sic_code', 
context: 'company',
validate: 'sic',
validateRequired: true,
})
    

  return (<React.Fragment
>
<div
 data-testid="PrimaryIndustrySicCode.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Add/PrimaryIndustrySicCode"
 style={{'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
<span
 data-testid="PrimaryIndustrySicCode.Text"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Add/PrimaryIndustrySicCode"
 className={`views-text ${styles.Text}`}
>
Primary Industry SIC Code
</span>
<Dropdown
 data-testid="PrimaryIndustrySicCode.Dropdown"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Add/PrimaryIndustrySicCode"
viewPath={`${viewPath}/Dropdown`}
 field="id"
 from={from}
 onClick={data.onChange}
 isInvalid={data.isInvalid}
 selected={data.value}
 minWidth={500}
 width={500}
 valueWidth={500}
/>
</div>
{children}
</React.Fragment>)
}